import { BaseTypography } from "components/common/BaseTypography";
import styled from "styled-components";
import {
  BORDER_RADIUS,
  FONT_SIZE,
  FONT_WEIGHT,
  media,
} from "styles/themes/constants";
import { flexColumn, flexColumnJustifyAlignCenter } from "utils/styles";
import { devices } from "utils/theme";

export const HeaderContainer = styled.header`
  background-color: #333;
  color: #fff;
  padding: 1.5rem;
`;

// Styled component for the header title
export const HeaderTitle = styled.h1`
  font-size: ${FONT_SIZE.xxs};
  font-weight: ${FONT_WEIGHT.medium};
  font-family: "Poppins";
  @media only screen and ${media.md} {
    font-size: ${FONT_SIZE.lg};
    font-weight: ${FONT_WEIGHT.medium};
  }
  margin: 0;
`;
export const Logo = styled.img``;

export const Header = styled.div`
  padding: 0rem 0px;
  display: flex;
  align-items: center;
  margin: 0px 0px 10px;
`;

export const AuthorWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 21.25rem;
  position: relative;
  max-width: 42.5rem;
  box-shadow: var(--box-shadow);
  border-radius: ${BORDER_RADIUS};
  transition: 0.3s;

  [data-theme="dark"] & {
    background: var(--secondary-background-color);
  }

  &:hover {
    box-shadow: var(--box-shadow-hover);
  }
`;

export const Author = styled.div<{ colorState: any }>`
  font-size: ${FONT_SIZE.lg};
  font-weight: ${FONT_WEIGHT.bold};
  color: ${(props) => props?.colorState?.fontColor};
  line-height: 1.5625rem;
  text-transform: capitalize;
  font-family: "Open Sans", Arial, sans-serif;
`;
export const StatusMessage = styled.div<{ status: string }>`
  font-size: ${FONT_SIZE.lg};
  font-weight: ${FONT_WEIGHT.bold};
  line-height: 1.5625rem;
  text-transform: capitalize;
  font-family: "Open Sans", Arial, sans-serif;
  color: ${(props) =>
    props.status === "Accepted" ? `var(--primary)` : `var(--red)`};
`;

export const InfoWrapper = styled.div`
  padding: 1.25rem;

  @media only screen and ${media.xl} {
    padding: 1rem;
  }

  @media only screen and ${media.xxl} {
    padding: 1.85rem;
  }
`;

export const InfoHeader = styled.div`
  display: flex;
  font-size: 1.1rem;
`;

export const Title = styled.div`
  font-size: ${FONT_SIZE.xl};
  font-weight: ${FONT_WEIGHT.semibold};
  width: 80%;
  line-height: 1.375rem;

  color: var(--text-main-color);

  @media only screen and ${media.md} {
    font-size: ${FONT_SIZE.xxl};
  }
`;

export const DateTime = styled(BaseTypography.Title)`
  font-size: ${FONT_SIZE.xs};
  color: var(--text-main-color);
  color: #333;
  padding-bottom: 10px;
  line-height: 1em;
  font-weight: 500;
`;

export const Description = styled.div<{ colorState: any }>`
  font-size: ${FONT_SIZE.md};
  color: ${(props) =>
    props?.colorState?.fontColor
      ? props?.colorState?.fontColor
      : "rgb(102, 102, 102)"};
  margin: 10px 0px 30px;

  @media only screen and ${media.xxl} {
    font-size: 1rem;
  }
`;

export const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.625rem;
  padding: 0 1.25rem 1.25rem;
`;

export const AcceptReject = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
  padding: 0px 0px;
  margin-top: 30px;
`;

export const ButtonWrapper = styled.div`
  // ${flexColumnJustifyAlignCenter};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  width: 160px;
  > * {
    margin-bottom: 1rem;
  }
`;

export const QRRequestedStyled = styled.div<{ colorState: any }>`
  width: 100%;
  margin: 0px auto;
  background: ${(props) =>
    props?.colorState?.backgroundColor
      ? props?.colorState?.backgroundColor
      : "var(--background)"};
  color: ${(props) => props?.colorState?.fontColor};
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.09);
`;

export const ContentWrapperStyled = styled.div`
  max-width: 1200px;
  margin: 0px auto;
  padding: 20px 20px;
`;

export const InfoContainerStyled = styled.div<{ colorState: any }>`
  margin-bottom: 20px;
  color: ${(props) => props?.colorState?.fontColor};
`;
export const InfoWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  & .label {
    width: 80px;
    font-weight: 600;
    /* color: #444; */
  }
  & .value {
  }
`;

export const IconStyle = styled.div<{ status: string }>`
  font-size: 30px;
  color: ${(props) =>
    props.status === "Accepted" ? `var(--primary)` : `var(--red)`};
`;

export const IntersectionImageContainerStyled = styled.div`
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fit, 1fr);
  gap: 40px;
  justify-items: start;

  @media ${devices.mobileSM} {
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  }
  & .individual-image {
    margin: 5px 0px 30px 0px;
    background: #fffa;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    & .desc {
      margin: 0px 0px 10px;
    }
    & .label {
      margin: 0px 0px 5px;
    }

    & .image {
      max-height: 300px;
      width: 100%;
      object-fit: cover;
    }
  }
`;

export const FooterContainer = styled.footer<{ colorState: any }>`
  background-color: ${(props) =>
    props?.colorState?.footerColor ? props?.colorState?.footerColor : "#333"};
  color: ${(props) =>
    props?.colorState?.footerFontColor
      ? props?.colorState?.footerFontColor
      : "#fff"};
  padding: 10px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  @media only screen and ${media.md} {
    flex-direction: row;
    padding: 15px 30px;
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Logod = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
`;

export const FooterText = styled.p`
  font-size: ${FONT_SIZE.xxxs};
  font-family: "Poppins";
  @media only screen and ${media.md} {
    font-size: ${FONT_SIZE.xs};
  }
`;

export const AssociateLogo = styled.div``;

export const FooterStyled = styled.div`
  & .image-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    padding: 10px;
    flex-wrap: wrap;
    img {
      height: 20px;

      @media only screen and ${media.md} {
        height: 40px;
      }
    }
  }
`;

export const TitleTypography = styled(BaseTypography.Title)<{
  colorState: any;
}>`
  color: ${(props) => props?.colorState?.fontColor} !important;
`;

export const TextTypography = styled(BaseTypography.Text)<{
  colorState: any;
}>`
  color: ${(props) => props?.colorState?.fontColor} !important;
`;

export const Text = styled.div`
  display: flex;
  align-items: center;
  margin: 0 auto;
  justify-content: center;
  margin-bottom: 50px;
`;
